"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HStack = exports.VStack = exports.Stack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const css_1 = __importDefault(require("@styled-system/css"));
const tools_1 = require("../../tools");
const Flex_1 = require("../Flex");
function Stack(_a) {
    var { spacing, direction = 'column' } = _a, props = __rest(_a, ["spacing", "direction"]);
    return jsx_runtime_1.jsx(StyledFlex, Object.assign({ spacing: spacing, direction: direction }, props), void 0);
}
exports.Stack = Stack;
const StyledFlex = tools_1.styled(Flex_1.Flex)(props => css_1.default({
    '& > * ~ *': {
        marginTop: props.direction === 'column' ? props.spacing : undefined,
        marginBottom: props.direction === 'column-reverse' ? props.spacing : undefined,
        marginLeft: props.direction === 'row' ? props.spacing : undefined,
        marginRight: props.direction === 'row-reverse' ? props.spacing : undefined,
    },
}));
function VStack(props) {
    return jsx_runtime_1.jsx(Stack, Object.assign({ direction: "column", align: "center" }, props), void 0);
}
exports.VStack = VStack;
function HStack(props) {
    return jsx_runtime_1.jsx(Stack, Object.assign({ direction: "row", align: "center" }, props), void 0);
}
exports.HStack = HStack;
//# sourceMappingURL=index.js.map